import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getAllCountries } from "../data/countries";
import { getUsStates } from "../data/us_states";
import { getListITC } from "../data/list_itc";
import TermsAndConditions from "../components/TermsAndConditions";
import ScheduleDemo from "../components/ScheduleDemo";

export const RequestTrialForm = () => {
  let countries = getAllCountries();
  let usStates = getUsStates();
  let list_itc = getListITC();
  const form = useRef();
  const [isShowAgreement, setIsShowAgreement] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const submitSuccess = useRef();
  const submitFailed = useRef();
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [displayState, setDisplayState] = useState(false);
  const [displayITC, setDisplayITC] = useState(false);
  const [isFormValid, setFormValid] = useState(false);

  const [mailerState, setMailerState] = useState({
    form: "request_trial_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    streetAddress: "",
    city: "",
    country: "",
    state: "",
    itc: "",
    email: "",
    phone: "",
    districtADM: "",
    termsAndConditions: "Agreed to terms and conditions",
    installAgreement:
      "Agreed to only install in non-production server agreement",
    howDidYouHear: "",
  });

  const [formErrors, setFormErrors] = useState({
    form: "request_trial_form",
    firstName: "",
    lastName: "",
    schoolDistrict: "",
    streetAddress: "",
    city: "",
    country: "",
    state: "",
    itc: "",
    email: "",
    phone: "",
    districtADM: "",
    termsAndConditions: "",
    installAgreement: "",
    howDidYouHear: "",
  });

  // function handleStateChange(e) {
  //   const { name, value } = e.target;
  //   setMailerState({ ...mailerState, [name]: value });

  //   if (name == "country" && value == "United States of America") {
  //     setDisplayState(true);
  //   } else if (name == "country" && value != "United States of America") {
  //     setDisplayState(false);
  //   }

  //   if (name == "state" && value == "Ohio") {
  //     setDisplayITC(true);
  //   } else if (name == "state" && value != "Ohio") {
  //     setDisplayITC(false);
  //   }
  // } // end of handleStateChange

  // const submitEmail = async (e) => {
  //   e.preventDefault();
  //   setIsFormSubmitted(isFormSubmitted);
  //   const api_url = process.env.REACT_APP_SEND_EMAIL;

  //   //validate form before sending
  //   let errors = {};
  //   // check values and remove white space before and after the value
  //   mailerState.firstName = mailerState.firstName.trim();
  //   mailerState.lastName = mailerState.lastName.trim();
  //   mailerState.schoolDistrict = mailerState.schoolDistrict.trim();
  //   mailerState.streetAddress = mailerState.streetAddress.trim();
  //   mailerState.city = mailerState.city.trim();
  //   mailerState.email = mailerState.email.trim();
  //   mailerState.phone = mailerState.phone.trim();
  //   mailerState.districtADM = mailerState.districtADM.trim();

  //   if (!mailerState.firstName) {
  //     errors.firstName = "First Name is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.lastName) {
  //     errors.lastName = "Last Name is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.schoolDistrict) {
  //     errors.schoolDistrict = "School District is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.streetAddress) {
  //     errors.streetAddress = "Street Address is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.city) {
  //     errors.city = "City is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.country) {
  //     errors.country = "Country is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.email) {
  //     errors.email = "Email is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.phone) {
  //     errors.phone = "Phone is required";
  //     setFormValid(false);
  //   } else if (mailerState.phone.length < 10) {
  //     errors.phone = "Phone number must be 10 digits";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (!mailerState.districtADM) {
  //     errors.districtADM = "District ADM is required";
  //     setFormValid(false);
  //   } else setFormValid(true);
  //   if (
  //     mailerState.country == "United States of America" &&
  //     !mailerState.state
  //   ) {
  //     errors.state = "State is required";
  //     setFormValid(false);
  //   } else if (
  //     mailerState.country == "United States of America" &&
  //     mailerState.state
  //   ) {
  //     errors.state = "";
  //     setFormValid(true);
  //   }
  //   if (mailerState.state == "Ohio" && !mailerState.itc) {
  //     errors.itc = "ITC is required";
  //     setFormValid(false);
  //   } else if (mailerState.state == "Ohio" && mailerState.itc) {
  //     errors.itc = "";
  //     setFormValid(true);
  //   }
  //   if (!mailerState.howDidYouHear) {
  //     errors.howDidYouHear =
  //       "Please select an option for 'How did you hear about us?'";
  //     setFormValid(false);
  //   } else {
  //     setFormValid(true);
  //   }

  //   setFormErrors(errors);

  //   if (isFormValid) {
  //     const response = await fetch(api_url, {
  //       method: "POST",
  //       headers: {
  //         "Content-type": "application/json",
  //       },
  //       body: JSON.stringify({ mailerState }),
  //     })
  //       .then((res) => res.json())
  //       .then(
  //         (res) => {
  //           setMailerState({
  //             form: "request_trial_form",
  //             firstName: "",
  //             lastName: "",
  //             schoolDistrict: "",
  //             streetAddress: "",
  //             city: "",
  //             state: "",
  //             itc: "",
  //             country: "",
  //             email: "",
  //             phone: "",
  //             districtADM: "",
  //             termsAndConditions: "Agreed to terms and conditions",
  //             installAgreement:
  //               "Agreed to only install in non-production server agreement",
  //           });
  //           setIsFormSubmitted(!isFormSubmitted);
  //           submitSuccess.current.value =
  //             "Thank you! We will be in touch soon.";
  //           setTimeout(function () {
  //             window.location.reload(1);
  //           }, 5000);
  //         },
  //         (error) => {
  //           setIsFormSubmitted(!isFormSubmitted);
  //           submitFailed.current.value = "Send Failed. Please try again later.";
  //           setTimeout(function () {
  //             window.location.reload(1);
  //           }, 5000);
  //         }
  //       );
  //     e.target.reset();
  //   }
  // }; // end of submitEmail

  function handleStateChange(e) {
    const { name, value } = e.target;
    setMailerState({ ...mailerState, [name]: value });

    if (name === "country" && value === "United States of America") {
      setDisplayState(true);
    } else if (name === "country" && value !== "United States of America") {
      setDisplayState(false);
    }

    if (name === "state" && value === "Ohio") {
      setDisplayITC(true);
    } else if (name === "state" && value !== "Ohio") {
      setDisplayITC(false);
    }
  } // end of handleStateChange

  const submitEmail = async (e) => {
    e.preventDefault();
    setIsFormSubmitted(isFormSubmitted);
    const api_url = process.env.REACT_APP_SEND_EMAIL;

    // Validate form before sending
    let errors = {};
    mailerState.firstName = mailerState.firstName.trim();
    mailerState.lastName = mailerState.lastName.trim();
    mailerState.schoolDistrict = mailerState.schoolDistrict.trim();
    mailerState.streetAddress = mailerState.streetAddress.trim();
    mailerState.city = mailerState.city.trim();
    mailerState.email = mailerState.email.trim();
    mailerState.phone = mailerState.phone.trim();
    mailerState.districtADM = mailerState.districtADM.trim();

    if (!mailerState.firstName) {
      errors.firstName = "First Name is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.lastName) {
      errors.lastName = "Last Name is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.schoolDistrict) {
      errors.schoolDistrict = "School District is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.streetAddress) {
      errors.streetAddress = "Street Address is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.city) {
      errors.city = "City is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.country) {
      errors.country = "Country is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.email) {
      errors.email = "Email is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.phone) {
      errors.phone = "Phone is required";
      setFormValid(false);
    } else if (mailerState.phone.length < 10) {
      errors.phone = "Phone number must be 10 digits";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (!mailerState.districtADM) {
      errors.districtADM = "District ADM is required";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    if (
      mailerState.country === "United States of America" &&
      !mailerState.state
    ) {
      errors.state = "State is required";
      setFormValid(false);
    } else if (
      mailerState.country === "United States of America" &&
      mailerState.state
    ) {
      errors.state = "";
      setFormValid(true);
    }

    if (mailerState.state === "Ohio" && !mailerState.itc) {
      errors.itc = "ITC is required";
      setFormValid(false);
    } else if (mailerState.state === "Ohio" && mailerState.itc) {
      errors.itc = "";
      setFormValid(true);
    }

    if (!mailerState.howDidYouHear) {
      errors.howDidYouHear =
        "Please select an option for 'How did you hear about us?'";
      setFormValid(false);
    } else {
      setFormValid(true);
    }

    setFormErrors(errors);

    if (isFormValid) {
      await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({ mailerState }),
      })
        .then((res) => res.json())
        .then(
          () => {
            setMailerState({
              form: "request_trial_form",
              firstName: "",
              lastName: "",
              schoolDistrict: "",
              streetAddress: "",
              city: "",
              state: "",
              itc: "",
              country: "",
              email: "",
              phone: "",
              districtADM: "",
              termsAndConditions: "Agreed to terms and conditions",
              installAgreement:
                "Agreed to only install in non-production server agreement",
            });
            setIsFormSubmitted(!isFormSubmitted);
            submitSuccess.current.value =
              "Thank you! We will be in touch soon.";
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          },
          () => {
            setIsFormSubmitted(!isFormSubmitted);
            submitFailed.current.value = "Send Failed. Please try again later.";
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        );
      e.target.reset();
    }
  }; // end of submitEmail

  return (
    <div>
      <div id="trialForm">
        <div>
          <section>
            {isFormSubmitted ? (
              <div className="left-col">
                <div
                  style={{
                    borderRadius: "5px",
                    width: "100%",
                    height: "20em",
                    padding: "6em 1em",
                    backgroundColor: "white",
                  }}
                >
                  <input
                    style={{
                      width: "100%",
                      textAlign: "center",
                      border: "none",
                      fontSize: "1.4em",
                      backgroundColor: "transparent",
                    }}
                    id="successMsg"
                    ref={submitSuccess}
                    value={successMsg}
                    onChange={(e) => setSuccessMsg(e.target.value)}
                    disabled
                  ></input>
                  <input
                    style={{
                      width: "100%",
                      textAlign: "center",
                      border: "none",
                      fontSize: "1.4em",
                      backgroundColor: "transparent",
                      color: "#cc0000",
                    }}
                    id="successMsg"
                    ref={submitFailed}
                    value={errMsg}
                    onChange={(e) => setErrMsg(e.target.value)}
                    disabled
                  ></input>
                </div>
              </div>
            ) : (
              <div className="left-col">
                <div>
                  <p>REQUEST 30 DAY TRIAL</p>
                  <h2>See what META Customization Catalog can do for you</h2>
                </div>

                <form ref={form} onSubmit={submitEmail}>
                  <p>Please fill out the form completely.</p>
                  <div>
                    <label>
                      First Name<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="firstName"
                      autoComplete="off"
                      value={mailerState.firstName}
                    />
                    {formErrors.firstName && (
                      <span className="errorMessage">
                        {formErrors.firstName}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      Last Name<span className="required">*</span>
                    </label>
                    <input
                      x
                      onChange={handleStateChange}
                      name="lastName"
                      autoComplete="off"
                      value={mailerState.lastName}
                    />
                    {formErrors.lastName && (
                      <span className="errorMessage">
                        {formErrors.lastName}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      School Distict<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="schoolDistrict"
                      autoComplete="off"
                      value={mailerState.schoolDistrict}
                    />
                    {formErrors.schoolDistrict && (
                      <span className="errorMessage">
                        {formErrors.schoolDistrict}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      Street Address<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="streetAddress"
                      autoComplete="off"
                      value={mailerState.streetAddress}
                    />
                    {formErrors.streetAddress && (
                      <span className="errorMessage">
                        {formErrors.streetAddress}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      City<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="city"
                      autoComplete="off"
                      value={mailerState.city}
                    />
                    {formErrors.city && (
                      <span className="errorMessage">{formErrors.city}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Country<span className="required">*</span>
                    </label>
                    <select
                      onChange={handleStateChange}
                      name="country"
                      value={mailerState.country}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    {formErrors.country && (
                      <span className="errorMessage">{formErrors.country}</span>
                    )}
                  </div>
                  <div className={displayState ? "show" : "hide"}>
                    <label>
                      State<span className="required">*</span>
                    </label>
                    <select
                      onChange={handleStateChange}
                      name="state"
                      value={mailerState.state}
                    >
                      <option value="">Select State</option>
                      {usStates.map((usState) => (
                        <option key={usState.id} value={usState.name}>
                          {usState.name}
                        </option>
                      ))}
                    </select>
                    {formErrors.state && (
                      <span className="errorMessage">{formErrors.state}</span>
                    )}
                  </div>
                  <div className={displayITC ? "show" : "hide"}>
                    <label>
                      ITC<span className="required">*</span>
                    </label>
                    <select
                      id="itc"
                      onChange={handleStateChange}
                      name="itc"
                      value={mailerState.itc}
                      className="upper"
                    >
                      <option value="">Select ITC</option>
                      {list_itc.map((list_itc) => (
                        <option key={list_itc.id} value={list_itc.name}>
                          {list_itc.name}
                        </option>
                      ))}
                    </select>
                    {formErrors.itc && (
                      <span className="errorMessage">{formErrors.itc}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Work Email<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="email"
                      autoComplete="off"
                      value={mailerState.email}
                    />
                    {formErrors.email && (
                      <span className="errorMessage">{formErrors.email}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      Phone<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="phone"
                      type="number"
                      autoComplete="off"
                      value={mailerState.phone}
                    />
                    {formErrors.phone && (
                      <span className="errorMessage">{formErrors.phone}</span>
                    )}
                  </div>
                  <div>
                    <label>
                      District ADM<span className="required">*</span>
                    </label>
                    <input
                      onChange={handleStateChange}
                      name="districtADM"
                      autoComplete="off"
                      value={mailerState.districtADM}
                    />
                    <p style={{ fontSize: "12px", marginBottom: "0" }}>
                      ADM or Average Daily Membership is the average number of
                      students in attendance on any given day.
                    </p>
                    {formErrors.districtADM && (
                      <span className="errorMessage">
                        {formErrors.districtADM}
                      </span>
                    )}
                  </div>
                  <div>
                    <label>
                      How did you hear about us?
                      <span className="required">*</span>
                    </label>
                    <select
                      onChange={handleStateChange}
                      name="howDidYouHear"
                      value={mailerState.howDidYouHear}
                    >
                      <option value="">Select an option</option>
                      <option value="PowerSchool User Group">
                        PowerSchool User Group
                      </option>
                      <option value="PowerSource">PowerSource</option>
                      <option value="Conference">Conference</option>
                      <option value="Referral from District">
                        Referral from District
                      </option>
                      <option value="YouTube">YouTube</option>
                      <option value="Web Search">Web Search</option>
                      <option value="Other">Other</option>
                    </select>
                    {formErrors.howDidYouHear && (
                      <span className="errorMessage">
                        {formErrors.howDidYouHear}
                      </span>
                    )}
                  </div>

                  {/* Conditional input for "Other" */}
                  {mailerState.howDidYouHear === "Other" && (
                    <div>
                      <label>
                        Please specify<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="howDidYouHearOther"
                        onChange={handleStateChange}
                        value={mailerState.howDidYouHearOther || ""}
                        placeholder="Please specify how you heard about us..."
                      />
                      {formErrors.howDidYouHearOther && (
                        <span className="errorMessage">
                          {formErrors.howDidYouHearOther}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex" id="request_demo">
                    <input
                      type="checkbox"
                      name="termsAndConditions"
                      value={mailerState.termsAndConditions}
                      required
                    />
                    <label>
                      I agree to the following{" "}
                      <a
                        href="#terms_and_conditions"
                        onClick={() => {
                          setIsShowAgreement(!isShowAgreement);
                        }}
                      >
                        terms and conditions
                      </a>{" "}
                      of the download<span className="required">*</span>
                    </label>
                  </div>
                  <div
                    id="terms_and_conditions"
                    className={isShowAgreement ? "show" : "hide"}
                  >
                    <TermsAndConditions />
                  </div>
                  <div className="flex" id="install_agreement">
                    <input
                      type="checkbox"
                      name="installAgreement"
                      value={mailerState.installAgreement}
                      required
                    />
                    <label>
                      This is a DEMO version of the META Powerschool
                      Customizations Catalog and by checking this box I consent
                      that I am only allowed to install this product on a
                      non-production server<span className="required">*</span>
                    </label>
                  </div>
                  <div className="submit_button">
                    <input
                      className="button"
                      type="submit"
                      value="Send Request"
                    ></input>
                  </div>
                </form>
              </div>
            )}{" "}
            {/* end of isFormSubmitted useState */}
            <div className="right-col">
              <div className="col-info">
                <h3
                  style={{
                    fontSize: "1.5em",
                    fontWeight: "500",
                    paddingBottom: "8px",
                    color: "#f0f0f0",
                  }}
                >
                  You're in great company!
                </h3>
                <p
                  style={{
                    fontSize: "1.2em",
                    padding: "8px 0",
                    color: "#dcdcdc",
                  }}
                >
                  Servicing 200,000+ Students in 70+ Disticts
                </p>
                <p
                  style={{
                    fontSize: "1.2em",
                    padding: "8px 0",
                    color: "#dcdcdc",
                  }}
                >
                  100+ unique customizations to enhance the end user PowerSchool
                  experience
                </p>
              </div>
              <div id="cta">
                <div>
                  <p className="bold">How can we help?</p>
                </div>
                <div className="cta-btns">
                  {/* <button className="btn_demo">
                    <a target="new" href="https://www.eventbrite.com/e/meta-solutions-customization-catalog-demonstration-tickets-408792578607">Schedule a Demo</a>
                  </button> */}
                  <ScheduleDemo />
                  <button className="btn_send_message">
                    <Link to="/contactForm">Send us a Message</Link>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RequestTrialForm;
